// Internal modules
import { $logger } from '@/lib/logger';

export const logShippingMethodsShownToFPTI = () => {
  $logger.fpti('shipping_method_shown', {
    state_name: 'shipping',
    transition_name: 'prepare_shipping_methods_shown',
  });
};

export const logMissingShippingMethodsToFPTI = () => {
  $logger.fpti('missing_shipping_methods', {
    state_name: 'shipping',
    transition_name: 'prepare_missing_shipping_methods',
  });
};

export const logFetchingShippingMethodsToFPTI = () => {
  $logger.fpti('fetching_shipping_method', {
    state_name: 'shipping',
    transition_name: 'process_fetching_shipping_method',
  });
};

export const logShippingMethodSelectedToFPTI = () => {
  $logger.fpti('shipping_method_selected', {
    state_name: 'shipping',
    transition_name: 'process_shipping_method_selected',
  });
};

export const logShippingInsuranceSelectedToFPTI = () => {
  $logger.fpti('shipping_insurance_selected', {
    state_name: 'shipping',
    transition_name: 'process_shipping_insurance_selected',
  });
};
